<script lang="ts">
    import { navigate } from "svelte-navigator";
    import { Button, Icon } from "sveltestrap";

    export let slot: string = '';
    export let href: string | number = -1;

    function onClick() {
        navigate(href as string);
    }

</script>

<Button color="light" {slot} on:click={onClick}>
    <Icon name="chevron-left" />
</Button>